var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdNuclear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF8A14",
    fillRule: "evenodd",
    className: "layer"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.03a4.98 4.98 0 0 0 3.72-1.66A5 5 0 1 0 12 17.03z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 13.302a1.267 1.267 0 0 0 1.094-1.897 1.269 1.269 0 0 0-1.727-.463 1.266 1.266 0 0 0 .634 2.36zM13.358 14.375a.478.478 0 0 0-.598-.203s.034.013-.157.065a2.27 2.27 0 0 1-1.187 0c-.192-.052-.157-.065-.157-.065a.478.478 0 0 0-.599.203L8 18.984a.48.48 0 0 0 .206.67s.24.148.607.295c1.012.409 2.1.622 3.197.624a8.604 8.604 0 0 0 3.197-.624c.368-.147.608-.295.608-.295a.482.482 0 0 0 .206-.67l-2.662-4.61zM20.46 10.85a8.592 8.592 0 0 0-1.06-3.08 8.587 8.587 0 0 0-2.137-2.458c-.313-.244-.56-.379-.56-.379a.48.48 0 0 0-.684.157l-2.66 4.61a.48.48 0 0 0 .123.62s-.006-.037.136.103c.14.14.263.3.365.474.1.177.177.362.228.554.05.192.022.168.022.168.031.24.234.419.475.419h5.322a.48.48 0 0 0 .478-.514s.008-.282-.048-.674zM9.785 11.62s-.028.023.023-.17a2.275 2.275 0 0 1 .593-1.027c.14-.14.135-.103.135-.103a.479.479 0 0 0 .124-.62L8 5.09a.478.478 0 0 0-.684-.157s-.248.135-.56.379a8.606 8.606 0 0 0-2.138 2.457c-.547.952-.906 2-1.06 3.081-.054.392-.047.674-.047.674a.478.478 0 0 0 .478.514H9.31a.48.48 0 0 0 .475-.419z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdNuclear);
export default __webpack_public_path__ + "static/media/icon-pd-nuclear.580e39d0e5921d06f8d87012cc11b930.svg";
export { ForwardRef as ReactComponent };